/**
 * --------------------------------------------------
 * Cards list filtering Module
 *
 * @module CardList
 * --------------------------------------------------
 */

export default {
    _$grid: null,
    _$paginationElem: null,
    _$cardTemplate: null,
    _$loadmoreBtn: null,

    // Variables for pagination and data
    _dataSection: null,
    _currentPage: null,
    _totalPages: null,
    _currentPost: null,
    _totalItems: null,

    // Initialize the CardList module
    setup: function () {

        console.log('CardList module initialized');
        // Set element selectors
        this._$grid = $('.rt-js-grid');
        this._$cardTemplate = $('.rt-js-card');
        this._$paginationElem = $('.rt-js-pagination');
        this._$loadmoreBtn = this._$paginationElem.find('.rt-js-loadmore');

        // Pagination variables
        this._dataSection = this._$grid.data('section');
        this._currentPage = this._$grid.data('current-page');
        this._totalPages = this._$grid.data('total-pages');
        this._currentPost = this._$grid.data('current-post');
        this._totalItems = this._$grid.data('total-items');

        // Add event listeners
        this.listeners();
    },

    // Add event listeners for pagination buttons
    listeners: function () {
        const _self = this;

        // Load more btn
        this._$loadmoreBtn.on('click', e => {
            e.preventDefault();

            // Load the data
            _self.onLoadMore();
        });
    },

    // Function to display cards
    displayCards: function (data) {
        // function variables
        const _self = this;
        let totalCards = Object.keys(data).length;
        const $cardTemplate = _self._$cardTemplate[0]; // get first card as template

        // Loop through the data and create cards
        for (let i = 0; i < totalCards; i++) {
            // Clone the card template
            let $newCard = $($cardTemplate).clone();
            let cardId = "card-" +  data[i].id;

            // Hide actual card
            $newCard.addClass('rt-card--hidden');

            // Add a unique ID to the new card
            $newCard.attr('id', cardId);

            // Append the new card to the grid
            _self._$grid.append($newCard[0]);

            //Feed the card with data
            _self._feedCard($newCard, data[i]);

            // Animate all cards after they're in the DOM
            setTimeout(() => {
                $newCard.removeClass('rt-card--hidden');
            }, (i + 1) * 50);
        }

        // Validate if all pages are loaded
        if (_self._currentPage === _self._totalPages) {
            // Hide the load more button if all pages are loaded
            _self._$loadmoreBtn.hide();
        }

        // Update the counter
        _self._updateCounter();
    },

    // Function to load data
    onLoadMore: function () {
        const _self = this;

        // Update pagination
        _self._currentPage++;
        _self._$grid.attr('data-current-page', _self._currentPage);

        // Load cards data from the API
        this.loadCards(data => {

            // Clean response object
            delete data.total_pages;
            delete data.current_page;
            delete data.total_posts;
            delete data.current_post_index;

            // Process and display the cards data
            this.displayCards(data);
        });
    },

    // load cards function, this has the endpoints url
    loadCards: function (cb) {
        // Set obj with urls for endpoints according to post type
        const endpointsList = {
            blog: 'rithum/v1/blog-api',
            resources: 'rithum/v1/resources-api',
            case_study: 'rithum/v1/case-studies-api',
            press: 'rithum/v1/press-api',
            partners: 'rithum/v1/partners-api',
            archive: 'rithum/v1/archive-api',
            // Add more endpoints as needed
        };

        // Set extra fields from each post type
        const extraFields = {
            blog: ['excluded'],
            resources: ['excluded'],
            case_study: ['excluded'],
            press: [],
            partners: [],
            archive: ['category'] // Assuming 'archive' is a post type with a category field
            // Add more fields for other post types if needed
        }

        // Add extra fields to the endpoint URL
        let extras = [];
        let totalExtras = extraFields[this._dataSection].length;

        // Loop through extra fields and push them to extras array
        for (let i = 0; i < totalExtras; i++) {
            extras.push($(this._$grid).attr('data-' + extraFields[this._dataSection][i]));
        }

        // set dynamic endpoint url with extras and current page
        let endpointUrl = '/wp-json/' + endpointsList[this._dataSection];

        // If there are extras, append them to the endpoint URL
        if (extras.length) {
            endpointUrl += '/' + extras.join('/');
        }

        // Append the current page to the endpoint URL
        endpointUrl += '/' + this._currentPage;

        // Ajax query to get data from the endpoint
        return $.ajax({
            url: endpointUrl,
        }).done(function (data) {
            cb(data)
        });
    },

    // Feed the card with helper function
    _feedCard: function (card, data) {

        
        // Validate if type is present in data
        if( data.type !== undefined ) {
            card.removeClass('disabled').removeClass('enabled'); // Remove any previous type class and add new one
            card.removeClass(data.type).addClass(data.type);
        }

        // Find all elements with class starting with 'rt-js-card__'
        const $elem = card.find('[class*="rt-js-card__"]');

        // Loop through each element and set its content based on the data
        for (let i = 0; i < $elem.length; i++) {
            console.log(data.date);
            const $currentElem = $($elem[i]);
            const dataKeyMatch = $currentElem.attr('class').match(/rt-js-card__([a-zA-Z0-9_-]+)/);
            if (!dataKeyMatch) continue;
            const dataKey = dataKeyMatch[1];

            if (data[dataKey] !== undefined) {
                if (dataKey === 'image') {
                    $currentElem.html(data.image); // For image sources
                } else if (dataKey === 'link') {
                    $currentElem.attr('href', data.link).attr('target', data.target); // For links
                } else {
                    $currentElem.html(data[dataKey]); // For text content
                }
            }
        }
    },

    _updateCounter() {
        const cardCount  = $('.rt-js-card').length;

        // Show the current post number
        this._$paginationElem.find('.rt-js-current-number').text(cardCount);
    }
}